import React from 'react';
import { Modal, Button, Box } from '@mui/material';

const CloverConnectHelp = ({ open, handleClose }) => {
    return (
        <Modal open={open} onClose={handleClose}>
            <Box sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: 600,
                maxWidth: '90vw',
                maxHeight: '80vh',
                overflowY: 'auto',
                bgcolor: 'background.paper',
                borderRadius: '8px',
                boxShadow: 24,
                p: 4
            }}>
                <h2 style={{ color: '#E13535', marginBottom: '12px' }}>Clover Merchant ID, API Token & Tender ID Setup</h2>
                <p style={{ marginBottom: 16, color: '#4B5563' }}>
                    Follow these clear, step-by-step instructions to:
                    <br />1) Find your Merchant ID, 2) Create an API Token with proper permissions, and 3) Retrieve a Tender ID for Oh My Food (OMF) integration.
                </p>

                <div style={{ marginBottom: 20 }}>
                    <h3 style={{ color: '#2C3142', marginBottom: 8 }}>1. Find Your Clover Merchant ID</h3>
                    <ol style={{ paddingLeft: 18, color: '#374151' }}>
                        <li>Login to the <a href="https://www.clover.com/dashboard" target="_blank" rel="noreferrer">Clover Dashboard</a>.</li>
                        <li>Click the yellow <strong>gear</strong> icon (Settings) at the top‑right corner.</li>
                        <li>In the Settings search bar, type <strong>Merchants</strong>. Click <em>Merchants – View and search for merchants linked to your Clover account. It will be down below of your Resturant Name</em></li>
                        <li>Example MID: <code>EA2NXBCW4JK21</code></li>
                        <li>Copy this Merchant ID securely and provide it in the OMF onboarding form.</li>
                    </ol>
                </div>

                <div style={{ marginBottom: 20 }}>
                    <h3 style={{ color: '#2C3142', marginBottom: 8 }}>2. Create a Custom Clover Tender (Tender ID)</h3>
                    <ol style={{ paddingLeft: 18, color: '#374151' }}>
                        <li>In Clover Dashboard, go to <strong>Settings</strong> → search <strong>Payments</strong> → click <strong>Payments</strong>.</li>
                        <li>Scroll to the <strong>Tenders</strong> section and click <strong>Edit</strong>.</li>
                        <li>In the pop‑up, click <strong>Create custom tender</strong>.</li>
                        <li>Enter a tender name (e.g., <strong>OMF Tender</strong>).</li>
                        <li>Do <u>not</u> select <strong>Open cash drawer</strong> (leave it unchecked).</li>
                        <li>Click <strong>Save</strong>.</li>
                        <li>Copy the generated <strong>Tender ID</strong> and provide it in the OMF onboarding form.</li>
                    </ol>
                    <div style={{ backgroundColor: '#F3F4F6', padding: 12, borderRadius: 6, marginTop: 8 }}>
                        <strong>Tip:</strong> The Tender ID appears as an alphanumeric string (e.g., <code>abcd1234-efgh5678</code>). Use only this ID.
                    </div>
                </div>

                <div style={{ marginBottom: 20 }}>
                    <h3 style={{ color: '#2C3142', marginBottom: 8 }}>3. Create a Clover API Token (with Required Permissions)</h3>
                    <ol style={{ paddingLeft: 18, color: '#374151' }}>
                        <li>Click <strong>Settings</strong> (gear icon, top‑right).</li>
                        <li>Search <strong>API tokens</strong> and select <em>API tokens – Secure communication between third‑party integrations and your merchant account.</em></li>
                        <li>Click <strong>Create new token</strong>.</li>
                        <li>Enter a token name (e.g., <strong>OMF</strong>).</li>
                        <li>Enable these <strong>required permissions</strong>:
                            <ul style={{ marginLeft: 16, marginTop: 6 }}>
                                <li>Inventory – <strong>Read</strong></li>
                                <li>Merchant – <strong>Read &amp; Write</strong></li>
                                <li>Orders – <strong>Read &amp; Write</strong></li>
                                <li>Payments – <strong>Read &amp; Write</strong></li>
                            </ul>
                        </li>
                        <li>Click <strong>Save</strong>.</li>
                        <li>Copy the generated token string and store it securely. Provide it to Oh My Food via our secure onboarding form.</li>
                    </ol>
                    <div style={{ backgroundColor: '#FEF3C7', padding: 12, borderRadius: 6, marginTop: 8 }}>
                        <strong>Security Tip:</strong> Treat this token like a password. If compromised, revoke and regenerate immediately.
                    </div>
                </div>

                <Button 
                    onClick={handleClose} 
                    variant="contained" 
                    sx={{ 
                        backgroundColor: '#E13535', 
                        '&:hover': { backgroundColor: '#c12b2b' } 
                    }}
                >
                    Close
                </Button>
            </Box>
        </Modal>
    );
};

export default CloverConnectHelp;
